import { DownloadLink, Maybe } from "@oysterhr/schema"
import { PdfViewer } from "./PdfViewer"

type MaybeFile = Maybe<Partial<DownloadLink>> | undefined

const isPdf = (file: MaybeFile) => {
  return file?.contentType?.includes("pdf") ?? false
}

const isImage = (file: MaybeFile) => {
  return file?.contentType?.includes("image") ?? false
}

const getContent = (file: MaybeFile) => {
  const url = file?.url ?? undefined

  return isImage(file) ? (
    <img src={url} alt="document" />
  ) : isPdf(file) ? (
    <PdfViewer file={file} />
  ) : null
}

export const getFileProperties = (file: MaybeFile) => {
  const filename = file?.title || file?.filename || undefined

  return {
    isPdf: isPdf(file),
    isImage: isImage(file),
    content: getContent(file),
    url: file?.url ?? undefined,
    base64: file?.base64 ?? undefined,
    filename,
  }
}

export const calculateFileSize = (size: number) => {
  const i = Math.floor(Math.log(size) / Math.log(1024))
  const parsedSize = (size / Math.pow(1024, i)).toFixed(2)
  const unit = ["B", "KB", "MB", "GB", "TB"][i]
  return `${parsedSize} ${unit}`
}
